import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardComponent} from './dashboard.component';
import {MainComponent} from './main/main.component';
import {ItemsComponent} from './items/items.component';
import {RouterModule} from '@angular/router';
import { ClubMemberComponent } from './club-member/club-member.component';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
  declarations: [
    DashboardComponent,
    MainComponent,
    ItemsComponent,
    ClubMemberComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule.forChild([
      {
        path: '', component: DashboardComponent, children: [
          {path: '', redirectTo: '/dashboard/main', pathMatch: 'full'},
          {path: 'main', component: MainComponent},
          {path: 'club-members', component: ClubMemberComponent},
          {path: 'items', component: ItemsComponent}
        ]
      }
    ])
  ],
  exports: [RouterModule]
})

export class DashboardModule {}
